import React, { useEffect } from "react";
import styled from "styled-components";
import { isMobile } from "../common/style";

const KakaoAdfit4 = () => {
  useEffect(() => {
    let ins = document.createElement("ins");
    let scr = document.createElement("script");
    ins.className = "kakao_ad_area";
    ins.style = "display:none;";
    scr.async = "true";
    scr.type = "text/javascript";
    scr.src = "//t1.daumcdn.net/kas/static/ba.min.js";
    ins.setAttribute("data-ad-unit", "DAN-h3N6R86WYz0qXdd0");
    ins.setAttribute("data-ad-width", "320");
    ins.setAttribute("data-ad-height", "50");
    document.querySelector(".adfit4").appendChild(ins);
    document.querySelector(".adfit4").appendChild(scr);
  }, []);
  return <Advert4 className="adfit4" />;
};

export default KakaoAdfit4;

const Advert4 = styled.div`
  display: none;

  ${isMobile} {
    display: block;
  }
`;
